/** "2-3 days", "2 days" when the range collapses, or "today" at zero.
 *
 * Zero is a real answer — a two-wheeler delivers the same day — and "0 days"
 * is not how anybody says it. */
export function formatEta(
  min: number | null | undefined,
  max: number | null | undefined,
): string | null {
  if (typeof min !== 'number' && typeof max !== 'number') return null;
  const low = typeof min === 'number' ? min : (max as number);
  const high = typeof max === 'number' ? max : (min as number);
  if (low === 0 && high === 0) return 'today';
  if (low === high) return `${low} ${low === 1 ? 'day' : 'days'}`;
  return `${low}\u2013${high} days`;
}
